import type { UnifiedTableRecord } from "../../../shared/ui/data-table/model/data-table-contract";

export interface OrderProcedureDetailRow {
  label: string;
  value: string;
}

export interface OrderProcedureResultSection {
  id: string;
  title: string;
  rows: OrderProcedureDetailRow[];
}

export interface OrderProcedure {
  id: string;
  orderType: string;
  orderDate: string;
  orderName: string;
  procCode: string;
  completionStatus: string;
  reviewStatus: string;
  orderDetails: OrderProcedureDetailRow[];
  resultDetails?: OrderProcedureDetailRow[];
  resultNotes?: string;
}

export const ordersProcedures: OrderProcedure[] = [
  {
    id: "urine-culture-routine-87086",
    orderType: "LAB ORDER",
    orderDate: "04/04/2022",
    orderName: "URINE CULTURE ROUTINE (87086)",
    procCode: "-",
    completionStatus: "Final",
    reviewStatus: "Reviewed",
    orderDetails: [
      { label: "Name", value: "URINE CULTURE ROUTINE (87086)" },
      { label: "Completion Status", value: "Final" },
      { label: "Reviewed Status", value: "Reviewed" },
      { label: "Order Date", value: "04/04/2022" },
      { label: "Provider", value: "Barton, Elizabeth" },
      { label: "Ordered For", value: "—" },
      { label: "Performed On", value: "04/04/2022" },
      { label: "Report Date", value: "04/06/2022" },
      { label: "Reviewed Date", value: "04/06/2022 07:47 PM" },
      { label: "Reviewed By", value: "Barton, Elizabeth" },
      { label: "Notify Provider", value: "Barton, Elizabeth" },
      { label: "LOINC", value: "630-7" },
      { label: "Comment", value: "—" },
      { label: "Diagnosis", value: "Vaginitis" },
      { label: "Source", value: "QUEST" },
      { label: "Order ID", value: "000017628" },
      { label: "Ext Accession", value: "MR069939H" },
      { label: "Req Code", value: "17628" },
      { label: "Text Description", value: "—" },
    ],
    resultDetails: [
      { label: "Name", value: "CULTURE, URINE, ROUTINE" },
      { label: "Value", value: "SEE NOTE" },
      { label: "Flags", value: "—" },
      { label: "Units", value: "—" },
      { label: "Normal Range", value: "—" },
      { label: "Completion Status", value: "Final" },
      { label: "Reviewed Status", value: "Reviewed" },
      { label: "Change Reason", value: "—" },
    ],
    resultNotes:
      "CULTURE, URINE, ROUTINE Micro Number: 13783542 Test Status: Final Specimen Source: Urine, vaginal Specimen Quality: Adequate Result: No Growth Test Performed at: QUEST DIAGNOSTICS-MIAMI 10200 COMMERCE PARKWAY MIRAMAR, FL 33025-3938 JULIE L FRIEDMAN, MD",
  },
  {
    id: "vaginitis-dna-probe-87510",
    orderType: "LAB ORDER",
    orderDate: "04/04/2022",
    orderName: "Vaginitis, DNA Probe, Affirm VP III (87510)",
    procCode: "-",
    completionStatus: "Final",
    reviewStatus: "Reviewed",
    orderDetails: [
      { label: "Name", value: "Vaginitis, DNA Probe, Affirm VP III (87510)" },
      { label: "Completion Status", value: "Final" },
      { label: "Reviewed Status", value: "Reviewed" },
      { label: "Order Date", value: "04/04/2022" },
      { label: "Provider", value: "Barton, Elizabeth" },
      { label: "Ordered For", value: "—" },
      { label: "Performed On", value: "04/04/2022" },
      { label: "Report Date", value: "04/05/2022" },
      { label: "Reviewed Date", value: "04/05/2022 11:20 AM" },
      { label: "Reviewed By", value: "Barton, Elizabeth" },
      { label: "Notify Provider", value: "Barton, Elizabeth" },
      { label: "LOINC", value: "12357-7" },
      { label: "Comment", value: "—" },
      { label: "Diagnosis", value: "Vaginitis" },
      { label: "Source", value: "QUEST" },
      { label: "Order ID", value: "000017510" },
      { label: "Ext Accession", value: "MR069940H" },
      { label: "Req Code", value: "87510" },
      { label: "Text Description", value: "—" },
    ],
    resultDetails: [
      { label: "Name", value: "AFFIRM VPIII MICROBIAL IDENTIFICATION" },
      { label: "Value", value: "SEE NOTE" },
      { label: "Flags", value: "—" },
      { label: "Units", value: "—" },
      { label: "Normal Range", value: "—" },
      { label: "Completion Status", value: "Final" },
      { label: "Reviewed Status", value: "Reviewed" },
      { label: "Change Reason", value: "—" },
    ],
    resultNotes:
      "Affirm VPIII microbial identification completed. Candida species, Gardnerella vaginalis, and Trichomonas vaginalis results are available in the source report.",
  },
  {
    id: "urinalysis-ua-dipstick-81003",
    orderType: "LAB ORDER",
    orderDate: "04/04/2022",
    orderName: "URINALYSIS (UA DIPSTICK) (URGENT CARE) (81003)",
    procCode: "-",
    completionStatus: "Partial",
    reviewStatus: "Partially Reviewed",
    orderDetails: [
      {
        label: "Name",
        value: "URINALYSIS (UA DIPSTICK) (URGENT CARE) (81003)",
      },
      { label: "Completion Status", value: "Partial" },
      { label: "Reviewed Status", value: "Partially Reviewed" },
      { label: "Order Date", value: "04/04/2022" },
      { label: "Provider", value: "Barton, Elizabeth" },
      { label: "Ordered For", value: "—" },
      { label: "Performed On", value: "04/04/2022" },
      { label: "Report Date", value: "04/04/2022" },
      { label: "Reviewed Date", value: "04/04/2022 05:28 PM" },
      { label: "Reviewed By", value: "Barton, Elizabeth" },
      { label: "Notify Provider", value: "Barton, Elizabeth" },
      { label: "LOINC", value: "50553-7" },
      { label: "Comment", value: "—" },
      { label: "Diagnosis", value: "Dysuria" },
      { label: "Source", value: "Office" },
      { label: "Order ID", value: "000018103" },
      { label: "Ext Accession", value: "—" },
      { label: "Req Code", value: "81003" },
      { label: "Text Description", value: "—" },
    ],
    resultDetails: [
      { label: "Name", value: "URINALYSIS DIPSTICK" },
      { label: "Value", value: "SEE NOTE" },
      { label: "Flags", value: "—" },
      { label: "Units", value: "—" },
      { label: "Normal Range", value: "—" },
      { label: "Completion Status", value: "Partial" },
      { label: "Reviewed Status", value: "Partially Reviewed" },
      { label: "Change Reason", value: "—" },
    ],
    resultNotes:
      "Urinalysis was partially reviewed. See original source for individual dipstick components and review history.",
  },
  {
    id: "follow-up-symptoms-worsen",
    orderType: "PROCEDURE",
    orderDate: "01/27/2017",
    orderName: "Follow up if no improvement or if symptoms worsen",
    procCode: "599",
    completionStatus: "Final",
    reviewStatus: "Reviewed",
    orderDetails: [
      {
        label: "Name",
        value: "Follow up if no improvement or if symptoms worsen",
      },
      { label: "Completion Status", value: "Final" },
      { label: "Reviewed Status", value: "Reviewed" },
      { label: "Order Date", value: "01/27/2017" },
      { label: "Provider", value: "Barton, Elizabeth" },
      { label: "Ordered For", value: "—" },
      { label: "Performed On", value: "01/27/2017" },
      { label: "Report Date", value: "01/27/2017" },
      { label: "Reviewed Date", value: "01/27/2017" },
      { label: "Reviewed By", value: "Barton, Elizabeth" },
      { label: "Notify Provider", value: "Barton, Elizabeth" },
      { label: "LOINC", value: "—" },
      { label: "Comment", value: "—" },
      { label: "Diagnosis", value: "Follow-up examination" },
      { label: "Source", value: "Office" },
      { label: "Order ID", value: "000000599" },
      { label: "Ext Accession", value: "—" },
      { label: "Req Code", value: "599" },
      { label: "Text Description", value: "—" },
    ],
  },
  {
    id: "us-abdomen-complete-76700",
    orderType: "PROCEDURE",
    orderDate: "01/27/2017",
    orderName:
      "US ABDOMEN COMPLETE (CBD, GB, KIDNEYS, LIVER, PANCREAS, SPLEEN, AORTA, IVC) (76700)",
    procCode: "76700",
    completionStatus: "Ordered",
    reviewStatus: "Not Reviewed",
    orderDetails: [
      {
        label: "Name",
        value:
          "US ABDOMEN COMPLETE (CBD, GB, KIDNEYS, LIVER, PANCREAS, SPLEEN, AORTA, IVC) (76700)",
      },
      { label: "Completion Status", value: "Ordered" },
      { label: "Reviewed Status", value: "Not Reviewed" },
      { label: "Order Date", value: "01/27/2017" },
      { label: "Provider", value: "Barton, Elizabeth" },
      { label: "Ordered For", value: "—" },
      { label: "Performed On", value: "—" },
      { label: "Report Date", value: "—" },
      { label: "Reviewed Date", value: "—" },
      { label: "Reviewed By", value: "—" },
      { label: "Notify Provider", value: "Barton, Elizabeth" },
      { label: "LOINC", value: "—" },
      { label: "Comment", value: "—" },
      { label: "Diagnosis", value: "Abdominal pain" },
      { label: "Source", value: "Office" },
      { label: "Order ID", value: "000076700" },
      { label: "Ext Accession", value: "—" },
      { label: "Req Code", value: "76700" },
      { label: "Text Description", value: "—" },
    ],
  },
];

export const getOrderProcedureById = (orderId: string | undefined) =>
  ordersProcedures.find((order) => order.id === orderId) ?? ordersProcedures[0];

export const ordersProceduresRecord: UnifiedTableRecord = {
  module: "orders-procedures",
  pageTitle: "Orders & Procedures",
  sections: [
    {
      id: "orders-procedures",
      title: "Orders & Procedures",
      tables: [
        {
          id: "orders-procedures-table",
          columns: [
            {
              key: "details",
              header: "",
              width: 34,
              rendererId: "orderDetails",
            },
            { key: "orderType", header: "Order Type", sortable: true },
            { key: "orderDate", header: "Order Date", sortable: true },
            {
              key: "orderName",
              header: "Order Name",
              sortable: true,
              rendererId: "orderName",
            },
            { key: "procCode", header: "Proc Code", sortable: true },
            {
              key: "completionStatus",
              header: "Completion Status",
              sortable: true,
            },
            { key: "reviewStatus", header: "Review Status", sortable: true },
          ],
          rows: ordersProcedures.map((order) => ({
            id: order.id,
            orderType: order.orderType,
            orderDate: order.orderDate,
            orderName: order.orderName,
            procCode: order.procCode,
            completionStatus: order.completionStatus,
            reviewStatus: order.reviewStatus,
          })),
          ui: {
            searchable: true,
            searchPlaceholder: "Search...",
            searchKeys: [
              "orderType",
              "orderDate",
              "orderName",
              "procCode",
              "completionStatus",
              "reviewStatus",
            ],
            downloadable: ["csv", "xls", "pdf"],
            showTableDownloads: true,
            defaultRowsPerPage: 10,
            rowsPerPageOptions: [5, 10, 20, 25],
          },
        },
      ],
    },
  ],
};
